import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Tooltip,
  ListItemIcon,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon as MUIListItemIcon,
  ListItemText,
  Typography,
  Badge,
} from "@mui/material";
import Logout from "@mui/icons-material/Logout";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import PeopleIcon from "@mui/icons-material/PeopleOutlineOutlined";
import ElectricMopedOutlinedIcon from "@mui/icons-material/ElectricMopedOutlined";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import ViewCompactAltOutlinedIcon from "@mui/icons-material/ViewCompactAltOutlined";
import GpsFixedOutlinedIcon from "@mui/icons-material/GpsFixedOutlined";
import { useLocation, useNavigate } from "react-router-dom";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import Fleeteaselogo from "../../../fleetease-logo.svg";


const AppHeader: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [userName, setUserName] = useState<string | null>(null);
  const [logoUrl, setLogoUrl] = useState<string | null>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setUserName(localStorage.getItem("name"));
    setLogoUrl(localStorage.getItem("logoUrl"));
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const notificationhandleClick = () => {
    navigate("/notificationList");
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const [openEVMenu, setOpenEVMenu] = useState(false);

  const handleEVMenuClick = () => {
    setOpenEVMenu(!openEVMenu);
  };

  const isMenuItemActive = (path: string) => location.pathname === path;
const userNameLogo = localStorage.getItem("name");

  const menuItems = [
    {
      label: "Overview",
      icon: <ViewCompactAltOutlinedIcon />,
      path: "/overview",
    },
    { label: "Rider Details", icon: <PeopleIcon />, path: "/userdetails" },
    {
      label: "EV Details",
      icon: <ElectricMopedOutlinedIcon />,
      path: "/evdetails",
    },
    {
      label: "Payment",
      icon: <PaymentOutlinedIcon />,
      path: "/paymentdetails",
    },
    {
      label: "IOT Details",
      icon: <GpsFixedOutlinedIcon />,
      path: "/iotdetails",
    },
    {
      label: "Ride End Request",
      icon: <PeopleIcon />,
      path: "/rideendrequest",
    },
    {
      label: "Wallet Deduction",
      icon: <PeopleIcon />,
      path: "/walletDeduction",
    },
  ];

  return (
    <div className="w-full">
      <AppBar
        position="sticky"
        className="bg-white border-b border-slate-200 shadow-sm"
        sx={{
          backgroundColor: "#FFFFFF",
          boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
        }}
      >
        <Toolbar className="justify-between px-4 sm:px-6 min-h-[64px]">
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={handleDrawerToggle}
            className="text-slate-700 hover:bg-slate-100 transition-colors duration-200 rounded-lg"
            sx={{
              "&:hover": {
                backgroundColor: "#f1f5f9",
              },
            }}
          >
            <MenuIcon className="text-slate-800" />
          </IconButton>

          <div className="flex items-center gap-2 sm:gap-4">
            <Tooltip title="Notifications" arrow>
              <IconButton
                onClick={notificationhandleClick}
                className="text-slate-600 hover:text-[#000000] hover:bg-slate-50 transition-all duration-200 rounded-lg"
                sx={{
                  "&:hover": {
                    backgroundColor: "#f8fafc",
                    color: "#000000",
                  },
                }}
              >
                <Badge badgeContent={0} color="error" className="text-slate-600">
                  <NotificationsOutlinedIcon className="text-xl sm:text-2xl" />
                </Badge>
              </IconButton>
            </Tooltip>

            <div className="flex items-center gap-2 sm:gap-3 pl-2 sm:pl-3 border-l border-slate-200">
              <Tooltip title="Account" arrow>
                <IconButton
                  onClick={handleClick}
                  className="text-slate-600 hover:text-[#1FCD5B] hover:bg-slate-50 transition-all duration-200 rounded-full"
                  sx={{
                    "&:hover": {
                      backgroundColor: "#f8fafc",
                      color: "#1FCD5B",
                    },
                  }}
                >
                  <AccountCircleOutlinedIcon className="text-2xl sm:text-3xl" />
                </IconButton>
              </Tooltip>

              <Typography
                variant="body1"
                className="text-slate-800 font-semibold text-sm sm:text-base hidden sm:block max-w-[120px] sm:max-w-[200px] truncate"
              >
                {userName || "User"}
              </Typography>
            </div>

            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              PaperProps={{
                elevation: 8,
                sx: {
                  mt: 1.5,
                  minWidth: 180,
                  borderRadius: "12px",
                  border: "1px solid #e2e8f0",
                  boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                  "& .MuiMenuItem-root": {
                    px: 2.5,
                    py: 1.5,
                    fontSize: "0.875rem",
                    borderRadius: "8px",
                    margin: "4px 8px",
                    "&:hover": {
                      backgroundColor: "#fef2f2",
                    },
                  },
                },
              }}
            >
              <MenuItem onClick={handleLogout} className="text-red-600 hover:text-red-700">
                <ListItemIcon className="min-w-0 mr-3">
                  <Logout fontSize="small" className="text-red-600" />
                </ListItemIcon>
                <span className="font-semibold">Logout</span>
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={handleDrawerToggle}
        PaperProps={{
          sx: {
            width: 280,
            backgroundColor: "#ffffff",
            boxShadow: "4px 0 6px -1px rgba(0, 0, 0, 0.1), 2px 0 4px -1px rgba(0, 0, 0, 0.06)",
          },
        }}
      >
        <Box className="h-full flex flex-col bg-white" role="presentation">
         <div className="px-4 py-3 border-b border-slate-200 bg-gradient-to-br from-slate-50 via-white to-slate-50">
  {(logoUrl || userNameLogo === "Neeraj") && (
    <div className="flex justify-center items-center">
      <img
        src={userNameLogo === "Neeraj" ? Fleeteaselogo : logoUrl || ""}
        alt="Company Logo"
        className="max-h-10 max-w-full object-contain"
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.style.display = "none";
        }}
      />
    </div>
  )}
</div>


          <List className="flex-1 py-3 overflow-y-auto">
            {menuItems.map((item, index) => {
              const isActive = isMenuItemActive(item.path);

              if (item.label === "EV Details") {
                return (
                  <React.Fragment key={item.label}>
                    <ListItem disablePadding className="mb-1">
                      <ListItemButton
                        onClick={handleEVMenuClick}
                        className={`rounded-lg mx-2 transition-all duration-200 ${
                          openEVMenu
                            ? "bg-slate-100 text-[#000000]"
                            : "hover:bg-slate-50"
                        }`}
                        sx={{
                          "&:hover": {
                            backgroundColor: "#f8fafc",
                          },
                        }}
                      >
                        <MUIListItemIcon className="min-w-0 mr-3">
                          <div
                            className={`transition-colors duration-200 ${
                              openEVMenu ? "text-[#000000]" : "text-slate-600"
                            }`}
                          >
                            {item.icon}
                          </div>
                        </MUIListItemIcon>
                        <ListItemText
                          primary={item.label}
                          primaryTypographyProps={{
                            className: `font-medium text-sm ${
                              openEVMenu ? "text-[#000000]" : "text-slate-700"
                            }`,
                          }}
                        />
                        <div
                          className={`transition-colors duration-200 ${
                            openEVMenu ? "text-[#000000]" : "text-slate-400"
                          }`}
                        >
                          {openEVMenu ? <ExpandLess /> : <ExpandMore />}
                        </div>
                      </ListItemButton>
                    </ListItem>

                    <Collapse in={openEVMenu} timeout="auto" unmountOnExit>
                      <List
                        component="div"
                        disablePadding
                        className="bg-gradient-to-br from-slate-50 to-slate-100/50 mx-2 rounded-lg mb-1 py-1.5 border border-slate-100"
                      >
                        <ListItemButton
                          selected={isMenuItemActive("/evdetails/ev-details-list")}
                          className="rounded-lg mx-2 my-0.5 transition-all duration-200"
                          onClick={() => {
                            navigate("/evdetails/ev-details-list");
                            setDrawerOpen(false);
                          }}
                          sx={{
                            pl: 4,
                            backgroundColor: isMenuItemActive("/evdetails/ev-details-list")
                              ? "#000000"
                              : "transparent",
                            color: isMenuItemActive("/evdetails/ev-details-list")
                              ? "#ffffff"
                              : "#475569",
                            "&:hover": {
                              backgroundColor: isMenuItemActive("/evdetails/ev-details-list")
                                ? "#1a1a1a"
                                : "#f1f5f9",
                            },
                            "&.Mui-selected": {
                              backgroundColor: "#000000",
                              color: "#ffffff",
                              "&:hover": {
                                backgroundColor: "#1a1a1a",
                              },
                            },
                          }}
                        >
                          <ListItemText
                            primary="EV Detail List"
                            primaryTypographyProps={{
                              className: "text-sm font-medium",
                              sx: {
                                color: isMenuItemActive("/evdetails/ev-details-list")
                                  ? "#ffffff"
                                  : "#475569",
                              },
                            }}
                          />
                        </ListItemButton>

                        <ListItemButton
                          selected={isMenuItemActive("/evdetails/ride-ended")}
                          className="rounded-lg mx-2 my-0.5 transition-all duration-200"
                          onClick={() => {
                            navigate("/evdetails/ride-ended");
                            setDrawerOpen(false);
                          }}
                          sx={{
                            pl: 4,
                            backgroundColor: isMenuItemActive("/evdetails/ride-ended")
                              ? "#000000"
                              : "transparent",
                            color: isMenuItemActive("/evdetails/ride-ended")
                              ? "#ffffff"
                              : "#475569",
                            "&:hover": {
                              backgroundColor: isMenuItemActive("/evdetails/ride-ended")
                                ? "#1a1a1a"
                                : "#f1f5f9",
                            },
                            "&.Mui-selected": {
                              backgroundColor: "#000000",
                              color: "#ffffff",
                              "&:hover": {
                                backgroundColor: "#1a1a1a",
                              },
                            },
                          }}
                        >
                          <ListItemText
                            primary="Ride Ended"
                            primaryTypographyProps={{
                              className: "text-sm font-medium",
                              sx: {
                                color: isMenuItemActive("/evdetails/ride-ended")
                                  ? "#ffffff"
                                  : "#475569",
                              },
                            }}
                          />
                        </ListItemButton>

                        <ListItemButton
                          selected={isMenuItemActive("/evdetails/ready-for-allotment")}
                          className="rounded-lg mx-2 my-0.5 transition-all duration-200"
                          onClick={() => {
                            navigate("/evdetails/ready-for-allotment");
                            setDrawerOpen(false);
                          }}
                          sx={{
                            pl: 4,
                            backgroundColor: isMenuItemActive(
                              "/evdetails/ready-for-allotment"
                            )
                              ? "#000000"
                              : "transparent",
                            color: isMenuItemActive("/evdetails/ready-for-allotment")
                              ? "#ffffff"
                              : "#475569",
                            "&:hover": {
                              backgroundColor: isMenuItemActive(
                                "/evdetails/ready-for-allotment"
                              )
                                ? "#1a1a1a"
                                : "#f1f5f9",
                            },
                            "&.Mui-selected": {
                              backgroundColor: "#000000",
                              color: "#ffffff",
                              "&:hover": {
                                backgroundColor: "#1a1a1a",
                              },
                            },
                          }}
                        >
                          <ListItemText
                            primary="Ready For Allotment"
                            primaryTypographyProps={{
                              className: "text-sm font-medium",
                              sx: {
                                color: isMenuItemActive("/evdetails/ready-for-allotment")
                                  ? "#ffffff"
                                  : "#475569",
                              },
                            }}
                          />
                        </ListItemButton>
                      </List>
                    </Collapse>
                  </React.Fragment>
                );
              }

              return (
                <ListItem key={item.label} disablePadding className="mb-1">
                  <ListItemButton
                    selected={isActive}
                    onClick={() => {
                      navigate(item.path);
                      setDrawerOpen(false);
                    }}
                    className={`rounded-lg mx-2 transition-all duration-200 ${
                      isActive
                        ? "bg-black text-white shadow-sm"
                        : "hover:bg-slate-50"
                    }`}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#f8fafc",
                      },
                      "&.Mui-selected": {
                        backgroundColor: "#000000",
                        color: "#ffffff",
                        "&:hover": {
                          backgroundColor: "#1a1a1a",
                        },
                        "& .MuiListItemIcon-root": {
                          color: "#ffffff",
                        },
                      },
                    }}
                  >
                    <MUIListItemIcon className="min-w-0 mr-3">
                      <div
                        className={`transition-colors duration-200 ${
                          isActive ? "text-white" : "text-slate-600"
                        }`}
                      >
                        {item.icon}
                      </div>
                    </MUIListItemIcon>
                    <ListItemText
                      primary={item.label}
                      primaryTypographyProps={{
                        className: `font-medium text-sm ${
                          isActive ? "text-white" : "text-slate-700"
                        }`,
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>

          <div className="border-t border-slate-200 p-4 bg-gradient-to-br from-slate-50 to-white mt-auto">
            {/* <div className="flex items-center justify-between mb-3">
            </div> */}
            <div
              onClick={handleLogout}
              className="flex items-center gap-3 px-3 py-2 rounded-lg cursor-pointer transition-all duration-200 hover:bg-red-50 group"
            >
              <div className="w-8 h-8 rounded-lg bg-red-100 flex items-center justify-center group-hover:bg-red-200 transition-colors">
                <Logout fontSize="small" className="text-red-600" />
              </div>
              <span className="text-red-600 font-medium text-sm group-hover:text-red-700">
                Logout
              </span>
            </div>
          </div>
        </Box>
      </Drawer>
    </div>
  );
};

export default AppHeader;
